module.exports = __webpack_public_path__ + "images/avatars/female/15.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/15.svg
// module id = luA4
// module chunks = 55